import { createContext, useContext, useMemo, useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getFaqs, deleteFaq } from "../../api/faq";
import useToaster from "../../components/alert";
import Const from "../../utils/constant";
import { useNavigate } from "react-router-dom";
import { getFaq, updateFaq } from "../../api/home";
import { generatePayload, getIntialValues } from "./helper";

const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const toaster = useToaster();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const [setTerm] = useState("");

  const getFaqsQuery = useQuery({
    queryKey: [""],
    queryFn: getFaq,
  });

  const getFaqQuery = useQuery({
    queryKey: [{limit: 200 }],
    queryFn: getFaqs,
  });

  const updateFaqQuery = useMutation({ mutationFn: updateFaq });

  const deleteFaqQuery = useMutation({ mutationFn: deleteFaq });

  const initialValues = useMemo(() => {
    const homeData = getFaqsQuery?.data?.data?.data?.[0] || {};

    return getIntialValues(homeData.page_content);
  }, [getFaqsQuery]);

  const handleSubmit = async (values) => {
    const payload = generatePayload(values);
    const homeData = getFaqsQuery?.data?.data?.data?.[0] || {};

    updateFaqQuery.mutate(
      { page_content: payload, id: homeData.id },
      {
        onSuccess: () => {
          toaster.success(Const.MESSAGES.SUCCESS, Const.MESSAGES.DATA_IS_UPDATED_SUCCESSFULLY);
          getFaqsQuery.refetch();
        },
      },
    );
    return;
  };

  const handleWorkDelete = (item) => {
    deleteFaqQuery.mutate(item.id, {
      onSuccess: () => {
        queryClient.invalidateQueries(["blogs"]);
        toaster.success(Const.MESSAGES.SUCCESS, "FAQ is deleted successfully.");
      },
    });
  };

  const handleAddBlogClick = () => {
    navigate("/faq/add");
  };

  const handleEditClick = (item) => {
    navigate(`/faq/add?id=${item.id}`);
  };

  const handleOnChange = (e) => {
    const { value } = e.target;
    setTerm(value);
  };

  return (
    <PageContext.Provider value={{ handleSubmit, initialValues, getFaqQuery, handleWorkDelete, handleAddBlogClick, handleEditClick, handleOnChange }}>
      {children}
    </PageContext.Provider>
  );
};

export const useBlogsProvider = () => {
  return useContext(PageContext);
};
